var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import SpinnerSvg from './spinner.icon.svg';
export const SpinnerIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: SpinnerSvg }));
_react_refresh_temp_1 = SpinnerIcon;
$RefreshReg$(_react_refresh_temp_1, "SpinnerIcon");
